import { BigNumber } from 'ethers'
import React from 'react'
import { getReadableNumber } from 'src/helpers/getReadableNumber'
import { normalizeToWei } from 'src/utils/normalizeToWei'
import { InfoBox } from '../InfoBox'

interface IProps {
  expectedAmount?: BigNumber
  targetToken: string
  targetTokenDecimals: number
}

export function WithdrawInfo({ expectedAmount, targetToken, targetTokenDecimals }: IProps) {
  return (
    <InfoBox
      infos={[
        {
          property: 'Output',
          value: `${
            expectedAmount
              ? getReadableNumber(normalizeToWei(expectedAmount, targetTokenDecimals))
              : '...'
          } ${targetToken}`,
          tooltip: 'Expected amount of target token',
        },
        {
          property: 'Max Slippage',
          value: '2%',
          tooltip: 'Max difference between expected and returned amount of target token',
        },
      ]}
    />
  )
}
